<template>
  <bean-source-page
    :type="type"
    :columns="columns"
    :form-columns="formColumns"
    :filter-columns="filterColumns"
    :actions="actions"
    :form="form"
    :title="$t('menu.redPacketJoga')"
    resource="red_packet_joga"
    :onFetchData="onFetchData"
    :onFormSubmit="handleSubmit"
  />
</template>

<script>
import { Vue, Component, Prop } from 'vue-property-decorator';
import { filterColumnsExtend, columnsExtend, formColumnsExtend } from '../admin_grapes/red_packets.js';
import _ from 'lodash';
import CustomListItemColumns from './custom_list/custom_list_item_columns';
import CustomListItemFormColumns from './custom_list/custom_list_item_form_columns';

@Component
export default class RedPacketJoga extends Vue {
  @Prop(String) type;

  // form 新建表单初始化数据（default数据）
  form = {
    type: 'RedPacket::Joga',
    code: '',
    kind: 'cashback',
    limit_one_person_total_receive_count: 0,
    limit_one_person_receive_count_per_day: 0,
  }

  /**
   * @param {Function} h - createElement
   * @param {Object} params
   * @param {String} params.type - page type enum: ['index', 'show', 'edit', 'new']
   * @param {String} params.resource -RESTful api resource name
   */
  filterColumns() {
    const array = [
      'brand_name_cont',
      'code_cont',
      'state_eq',
    ].filter(Boolean)

    return filterColumnsExtend(array)
  }

  /**
   * @param {Function} h - createElement
   * @param {Object} params
   * @param {String} params.type - page type enum: ['index', 'show', 'edit', 'new']
   * @param {String} params.resource -RESTful api resource name
   */
  columns(h, { type }) {
    const array = [
      type === 'show' && 'id',
      'code',
      'total_amount',
      {
        key: 'state',
        width: 110,
      },
      {
        key: 'expired_at',
        width: 160,
      },
      'brand',
      type === 'show' && 'received_count',
      type === 'show' && 'received_amount',
      type === 'show' && {
        key: 'qrcode',
        renderCell: 'storageAttachment'
      },
      type === 'show' && 'limit_one_person_total_receive_count',
      type === 'show' && 'limit_one_person_receive_count_per_day',
      type === 'show' && {
        prop: 'custom_list_item_attributes',
        label: this.$t('redPacket.customListItem'),
        renderCell: (h, { props: { value } }) => {
          if (value) {
            return <bean-table height={null} value={[value]} columns={CustomListItemColumns.call(this, { ...value, kind: 'image' })} />
          }
        }
      },
      type === 'show' && 'created_at',
      type === 'show' && 'updated_at',
    ].filter(Boolean)

    return columnsExtend(array)
  }

  /**
   * @param {Function} h - createElement
   * @param {Object} params
   * @param {String} params.type - page type enum: ['index', 'show', 'edit', 'new']
   * @param {String} params.resource - RESTful api resoure name
   * @param {Object} params.data - current form data
   * @param {Function} params.change - invoke this method to sync form change({ field: 'new value' })
   */
  formColumns(h, { data, type }) {
    const array = [
      {
        key: 'brand_id',
        label: this.$t('model.brand'),
      },
      {
        key: 'code',
        renderCell: {
          props: {
            disabled: true,
          }
        }
      },
      {
        key: 'total_amount',
        renderCell: {
          hint: this.$t('hint.cannotChangeAfterCreate'),
          props: {
            disabled: type === 'edit',
          }
        }
      },
      {
        key: 'limit_one_person_total_receive_count',
        renderCell: {
          hint: this.$t('hint.zeroMeansNoLimit'),
          required: true,
        }
      },
      {
        key: 'limit_one_person_receive_count_per_day',
        renderCell: {
          hint: this.$t('hint.zeroMeansNoLimit'),
          required: true,
        }
      },
      (type === 'new' || ['init', 'actived'].includes(data.state)) && 'expired_at',
      {
        prop: 'custom_list_item_attributes',
        label: this.$t('redPacket.customListItem'),
        renderCell: {
          component: 'staticNestForm',
          props: {
            columns: () => {
              const row = data.custom_list_item_attributes || {};
              return CustomListItemFormColumns.call(this, row, { ...data, kind: 'image' });
            },
          }
        }
      },
    ].filter(Boolean)

    return formColumnsExtend(array, { data: data, type: type })
  }

  /**
   * @param {Object} scope -页面/表格 scope 数据
   * @param {Object} scope.row - 详情页/表格行 数据
   * @param {Object} sourcePageScope
   * @param {Function} sourcePageScope.remove - sourcePage删除方法
   * @param {Function} sourcePageScope.reload - sourcePage重新请求页面数据
   */
  actions({ row }, { remove }) {
    return [
      {
        component: 'routeButton',
        props: {
          label: this.$t('edit'),
          to: { name: 'red_packet_joga.edit', params: { id: row.id } }
        }
      },
      {
        component: 'confirmButton',
        props: {
          label: this.$t('destroy'),
          type: 'danger',
          can: 'red_packets.destroy'
        },
        on: {
          confirm: () => remove(row.id)
        }
      }
    ].filter(Boolean);
  }

  async onFetchData({ type }) {
    if (type === 'index') {
      const { data, pagination } = await this.$request.get('/red_packets', { params: { ...this.$route.query, type_eq: 'RedPacket::Joga' } });
      return {
        data,
        pagination
      }
    }

    if (type === 'show' || type === 'edit') {
      const data = await this.$request.get(`/red_packets/${this.$route.params.id}`);
      if (type === 'edit') {
        const item = data.custom_list_item_attributes;
        switch (_.get(item, 'target_type')) {
          case ('Merchant'):
            item.merchant_id = item.target_id;
            break;
          case ('TicketEvent'):
            item.ticket_event_id = item.target_id;
            break;
        }
      }
      return { data };
    }

    if (type === 'new') {
      const data = await this.$request.get('/red_packets/get_uniq_code');
      return {
        data: {
          ...this.form,
          ...data,
        }
      };
    }
  }

  beforeSubmit({ data }) {
    const formBody = _.cloneDeep(data);
    const item = formBody.custom_list_item_attributes;
    switch (_.get(item, 'target_type')) {
      case ('Merchant'):
        item.target_id = item.merchant_id;
        delete item.merchant_id;
        break;
      case ('TicketEvent'):
        item.target_id = item.ticket_event_id;
        delete item.ticket_event_id;
        break;
    }
    return formBody;
  }

  async handleSubmit({ data, type }) {
    const formBody = this.beforeSubmit({ data });
    if (type === 'new') {
      const response = await this.$request.post('/red_packets', formBody);
      this.$message.success(this.$t('bean.createSuccess'));
      this.$router.push({ name: 'red_packet_joga.show', params: { id: response.id } });
    } else {
      await this.$request.put(`/red_packets/${formBody.id}`, formBody);
      this.$message.success(this.$t('bean.updateSuccess'));
      this.$router.push({ name: 'red_packet_joga.show', params: { id: formBody.id } });
    }
  }
}

export const route = [
  {
    path: '/red_packet_joga',
    name: 'red_packet_joga.index',
    component: RedPacketJoga,
    props: {
      type: 'index',
    },
    meta: {
      can: 'red_packets.read'
    }
  },
  {
    path: '/red_packet_joga/new',
    name: 'red_packet_joga.new',
    component: RedPacketJoga,
    props: {
      type: 'new',
    },
    meta: {
      can: 'red_packets.create'
    }
  },
  {
    path: '/red_packet_joga/:id',
    name: 'red_packet_joga.show',
    component: RedPacketJoga,
    props: {
      type: 'show',
    },
    meta: {
      can: 'red_packets.read'
    }
  },
  {
    path: '/red_packet_joga/:id/edit',
    name: 'red_packet_joga.edit',
    component: RedPacketJoga,
    props: {
      type: 'edit'
    },
    meta: {
      can: 'red_packets.update'
    }
  }
]
</script>

<style scoped lang="scss">
  /deep/.admin-static-nest-form {
    .el-form-item {
      margin-bottom: 20px;
    }
  }
</style>
